<template>
  <div
    class="tei-option-status-icon"
    :class="[
      `tei-option-status-icon--${status}`,
    ]"
  >
    <CheckIconSmall
      v-if="status === 'correct' || status === 'selected'"
      class="tei-option-status-icon__icon"
    />
    <XIconSmall
      v-if="status === 'incorrect'"
      class="tei-option-status-icon__icon"
    />
  </div>
</template>

<script>
import CheckIconSmall from '@/components/ui-elements/texas-icons/CheckIconSmall.vue';
import XIconSmall from '@/components/ui-elements/texas-icons/XIconSmall.vue';

export default {
  name: 'TEIOptionStatusIcon',
  components: {
    CheckIconSmall,
    XIconSmall,
  },
  props: {
    status: {
      type: String,
      default: 'correct', // correct, incorrect, selected, empty
    },
  },
};
</script>

<style lang="stylus">
.tei-option-status-icon {
  align-items: center;
  border: 5px solid $nebula-color-white;
  border-radius: 50%;
  display: inline-flex;
  height: $nebula-space-6x;
  justify-content: center;
  width: $nebula-space-6x;

  &--correct {
    background-color: var(--tei-correct-color);
  }

  &--incorrect {
    background-color: var(--tei-incorrect-color);
  }

  &--selected {
    background-color: var(--tei-button-primary-color);
  }

  &--empty {
    background-color: transparent;
    border-color: var(--tei-button-primary-color);
  }

  &__icon {
    display: block;
  }
}
</style>
